var _rect, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "webGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3B82F6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2563EB",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "codeGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1E293B",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0F172A",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#F8FAFC",
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E2E8F0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 36,
    rx: 8,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 18,
    r: 5,
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 18,
    r: 5,
    fill: "#F59E0B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 18,
    r: 5,
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 50)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fill: "#64748B",
    fontFamily: "monospace",
    fontSize: 12
  }, "1"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 45,
    fill: "#64748B",
    fontFamily: "monospace",
    fontSize: 12
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    fill: "#64748B",
    fontFamily: "monospace",
    fontSize: 12
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 95,
    fill: "#64748B",
    fontFamily: "monospace",
    fontSize: 12
  }, "4"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fill: "#3B82F6",
    fontFamily: "monospace",
    fontSize: 12
  }, "import"), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 20,
    fill: "#E2E8F0",
    fontFamily: "monospace",
    fontSize: 12
  }, "React from 'react';"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 45,
    fill: "#3B82F6",
    fontFamily: "monospace",
    fontSize: 12
  }, "const"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 45,
    fill: "#E2E8F0",
    fontFamily: "monospace",
    fontSize: 12
  }, "App = () => {"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 70,
    fill: "#E2E8F0",
    fontFamily: "monospace",
    fontSize: 12
  }, "return ("), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 95,
    fill: "#8B5CF6",
    fontFamily: "monospace",
    fontSize: 12
  }, "&lt;div&gt;"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 160)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 65,
    rx: 6,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 100,
    height: 8,
    rx: 4,
    fill: "#3B82F6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 35,
    width: 260,
    height: 15,
    rx: 4,
    fill: "#3B82F6",
    opacity: 0.3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 120)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 20,
    fill: "#ffffff",
    stroke: "#61DAFB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 4,
    fill: "#61DAFB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 25,
    rx: 10,
    ry: 4,
    fill: "none",
    stroke: "#61DAFB",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 25 25",
    to: "360 25 25",
    dur: "10s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(340, 120)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#3178C6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 27,
    fill: "#FFFFFF",
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: 18
  }, "TS"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(330, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#webGradient)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,35 L365,35 M355,25 L355,45",
    stroke: "#3B82F6",
    strokeWidth: 2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 220)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "url(#webGradient)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 35,
    fill: "#3B82F6",
    fontFamily: "monospace",
    fontSize: 20
  }, "&lt;/&gt;"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#E2E8F0",
    strokeWidth: 1.5,
    strokeDasharray: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35,120 L35,200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,120 L360,200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDev);
export default __webpack_public_path__ + "static/media/web_dev.520bff79d09001e1f17417a9eaa0191a.svg";
export { ForwardRef as ReactComponent };